import { RespondToMfaForm } from '@/components/auth/respondToMfaForm';
import { CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { routes } from '@/types/routes';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

export const Route = createFileRoute('/_auth/(login)/verify')({
  component: RouteComponent,
  beforeLoad: ({ context }) => {
    if (!context.auth.username || !context.auth.loginSession) {
      redirect({
        to: routes.login,
        replace: true,
        throw: true,
      });
    }
  },
});

function RouteComponent() {
  const { t } = useTranslation();

  return (
    <>
      <CardHeader className="gap-space-2xs">
        <CardTitle className="text-heading-lg-semibold">
          { t('verify.title', { ns: 'auth' }) }
        </CardTitle>
        <CardDescription className="text-body-md-normal">
          { t('verify.description', { ns: 'auth' }) }
        </CardDescription>
      </CardHeader>

      <CardContent className="flex flex-col items-center">
        <RespondToMfaForm />
      </CardContent>
    </>
  );
}
